/**
 * Formata um valor numérico como preço em BRL.
 * Compartilhado entre app (Vue) e server (Nitro).
 */
export function formatPrice(value: number | null | undefined): string {
  if (value == null) return ''
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

/**
 * Calcula o percentual de desconto entre preço original e preço atual.
 */
export function calcDiscount(originalPrice: number, currentPrice: number): number {
  if (originalPrice <= 0) return 0
  return Math.round(((originalPrice - currentPrice) / originalPrice) * 100)
}

/**
 * Retorna o preço formatado de forma compacta (ex: R$ 1,2 mil).
 */
export function formatPriceCompact(value: number): string {
  if (value >= 1000) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value)
  }
  return formatPrice(value)
}
